import React, { useLayoutEffect, useEffect, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { UseTranslationProps } from 'types/UseTranslationProps';
import TitleNavBarContext from 'context/TitleNavBarContext';
import SystemNotifyContext from 'context/SystemNotifyContext';
import AddBtn from 'components/AddBtn';
import ListMenuItensLocation from 'components/ListMenuItensLocation';
import FormMenuItemLocation from 'components/FormMenuItemLocation';
import { MenuItemLocationProps } from 'types/MenuItemLocationProps';
import { getItensMenu } from './reqs';

export default function MenuItensLocation() {
	const { i18n, t }: UseTranslationProps = useTranslation();
	const { setDataAbouTitle } = useContext(TitleNavBarContext);
	const { handleNotify } = useContext(SystemNotifyContext);

	const [isFormOpen, setIsFormOpen] = useState(false);
	const [isReq, setIsReq] = useState(false);
	const [itemMenuToEdit, setItemMenuToEdit] =
		useState<null | MenuItemLocationProps>(null);
	const [listMenuItensLocation, setListMenuItensLocation] = useState<
		MenuItemLocationProps[]
	>([]);

	useEffect(() => {
		(async () => {
			setIsReq(true);
			await getItensMenu(setListMenuItensLocation, handleNotify);
			setIsReq(false);
		})();
	}, []);

	//muda titulo do componente
	useLayoutEffect(() => {
		setDataAbouTitle((value) => ({
			...value,
			title: 'navBarOptions.localToItensMenu'
		}));
	}, [i18n?.language]);

	return (
		<S.container>
			<AddBtn
				anyFunction={() => {
					setIsFormOpen(true);
				}}
				text={t('menuItensLocation.addNewItem')}
			/>
			<ListMenuItensLocation
				setListMenuItensLocation={setListMenuItensLocation}
				listMenuItensLocation={listMenuItensLocation}
				setIsOpen={setIsFormOpen}
				setUserToEdit={setItemMenuToEdit}
				isReq={isReq}
			/>
			{isFormOpen && (
				<FormMenuItemLocation
					isOpen={isFormOpen}
					setIsOpen={setIsFormOpen}
					itemMenuToEdit={itemMenuToEdit}
					setItemMenuToEdit={setItemMenuToEdit}
					setListMenuItensLocation={setListMenuItensLocation}
				/>
			)}
		</S.container>
	);
}
